module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.507ae4ce.jpeg";